import { render, staticRenderFns } from "./shipment-bill-log.vue?vue&type=template&id=58dd4327&scoped=true&"
import script from "./shipment-bill-log.vue?vue&type=script&lang=js&"
export * from "./shipment-bill-log.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dd4327",
  null
  
)

export default component.exports